import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-book-open-fill"></i>
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-background-50">
                天堂<span className="text-accent-300">漫画</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              天堂漫画官网聚合全站漫画总目录，全库完整书库持续更新，海量资源全收录。热门连载、冷门完结一站找全，省去多站切换的麻烦。
            </p>
            <div className="mt-4 flex items-center gap-3 text-sm text-background-300">
              <i className="ri-mail-line"></i>
              <span>service@tiantangmh.example</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-accent-300">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li><Link to="/" className="transition-colors hover:text-background-50">首页</Link></li>
              <li><Link to="/categories" className="transition-colors hover:text-background-50">全站分类</Link></li>
              <li><Link to="/ranking" className="transition-colors hover:text-background-50">人气排行</Link></li>
              <li><Link to="/featured" className="transition-colors hover:text-background-50">新作专题</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-background-50">关于我们</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-background-50">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-accent-300">漫画分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm text-background-300">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/categories?type=${c.slug}`} className="whitespace-nowrap transition-colors hover:text-background-50">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-accent-300">热门作品</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              {comics.slice(0, 5).map((c) => (
                <li key={c.id} className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-accent-400"></i>
                  <span className="whitespace-nowrap transition-colors hover:text-background-50">{c.title}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/20 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 天堂漫画 Tiantang Manga. 保留所有权利。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-fill text-accent-400"></i>
            为每一份热爱阅读的心而存在
          </p>
        </div>
      </div>
    </footer>
  );
}